import { PROFILE_ENVIRONMENT, PROFILE_ID } from "./enums";

export default {
  chatbotId: PROFILE_ID.SKY_CL_CHATBOT_ES,
  credentials: [
    {
      environment: PROFILE_ENVIRONMENT.DEVELOPMENT,
      inbentaKey: "BeMVYEN4auFD9hgbtNhLjTTHL30DnTHIVKbQrw6RGbk=",
      domainKey:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJwcm9qZWN0Ijoic2t5X2NsX2NoYXRib3RfZXMiLCJkb21haW5fa2V5X2lkIjoiQmcwY2tydHN4TWpZOGQwR2xlWWxUUTo6In0.oUHVOvHPfCJuUmSjbiWFgGMSwa4ENOhGt3VRCiyk01N5GBGnjUFB-_CS-2rj6ZQAng5c-PwzjlXL9uHvcun-NA",
    },
    {
      environment: PROFILE_ENVIRONMENT.PRODUCTION,
      inbentaKey: "BeMVYENb0kY41hYVs2ulHPqDEo6U1nfoBR+QTaUQXUk=",
      domainKey:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJwcm9qZWN0Ijoic2t5X2NsX2NoYXRib3RfZXMiLCJkb21haW5fa2V5X2lkIjoiQmhocUQ1U0Y1Q2I2b1d0clpMZ2F3UTo6In0.YBUp1sXt5ImQWQC0HSjZlZ3rM83ZVeVtbfPiMKbsbmwVIzXV66ewBr0pcQRqpN3-MGxNp_GrsQAhrYJlqoBu2A",
    },
  ],
};
